package com.shadowings.gero.presentation.screen.characters

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.GameConstants
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.component.avatars.AlynAvatar
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import compose.icons.FeatherIcons
import compose.icons.feathericons.Lock
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.basco
import gero.composeapp.generated.resources.chiudi_btn
import gero.composeapp.generated.resources.builder_pro_unlock_btn
import gero.composeapp.generated.resources.custom_hat_locked_caption
import gero.composeapp.generated.resources.custom_hat_locked_desc
import gero.composeapp.generated.resources.custom_hat_locked_title
import gero.composeapp.generated.resources.custom_hat_type_beret
import gero.composeapp.generated.resources.custom_hat_type_egypt
import gero.composeapp.generated.resources.custom_hat_type_explorer
import gero.composeapp.generated.resources.custom_hat_type_viking
import gero.composeapp.generated.resources.custom_title_bg
import gero.composeapp.generated.resources.custom_title_body
import gero.composeapp.generated.resources.custom_title_earrings
import gero.composeapp.generated.resources.custom_title_eyes
import gero.composeapp.generated.resources.custom_title_face
import gero.composeapp.generated.resources.custom_title_hair
import gero.composeapp.generated.resources.custom_title_hat
import gero.composeapp.generated.resources.custom_title_hat_accent
import gero.composeapp.generated.resources.custom_title_hat_type
import gero.composeapp.generated.resources.custom_title_mouth
import gero.composeapp.generated.resources.custom_title_shirt
import gero.composeapp.generated.resources.egypt
import gero.composeapp.generated.resources.indiana
import gero.composeapp.generated.resources.viking
import org.jetbrains.compose.resources.stringResource

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun AlynCharacterScreenPreview() {
    AppTheme {
        Surface {
            AlynCharacterScreen(
                userData = UserData(
                    alynColors = mapOf(
                    )
                ),
                onAlynColorChanged = { _, _ -> }
            )
        }
    }
}

@Composable
fun AlynCharacterScreen(
    userData: UserData,
    onAlynColorChanged: (categoryKey: String, index: Int) -> Unit,
    onResetClick: () -> Unit = {},
    onPurchaseFullVersion: () -> Unit = {},
    modifier: Modifier = Modifier,
) {
    val bgColorIndex =
        (userData.alynColors[CharacterConsts.BG_KEY] ?: 0).coerceIn(0, backgroundOptions.size - 1)
    val skinColorIndex = (userData.alynColors["skin"] ?: 0).coerceIn(0, skinOptions.size - 1)
    val hairColorIndex = (userData.alynColors["hair"] ?: 7).coerceIn(0, hairOptions.size - 1)
    val earringsIndex = (userData.alynColors["earrings"] ?: 0).coerceIn(0, earringsOptions.size - 1)
    val shirtColorIndex = (userData.alynColors["shirt"] ?: 7).coerceIn(0, shirtOptions.size - 1)
    val hatBarColorIndex = (userData.alynColors["hatBar"] ?: 3).coerceIn(0, hatBarOptions.size - 1)
    val hatColorIndex = (userData.alynColors["hat"] ?: 0).coerceIn(0, hatOptions.size - 1)
    val eyesColorIndex = (userData.alynColors["eyes"] ?: 1).coerceIn(0, eyesOptions.size - 1)
    val mouthColorIndex = (userData.alynColors["mouth"] ?: 0).coerceIn(0, mouthOptions.size - 1)
    val hatTypeIndex = (userData.alynColors[CharacterConsts.HAT_TYPE_KEY] ?: 0).coerceIn(0, 3)

    // livello minimo richiesto per ogni cappello, in ordine di opzione (0 = nessun requisito)
    val hatTypeLevelRequirements = listOf(0, 5, 10, 20)
    val userLevel = GameConstants.getPlayerLevel(userData.experience)
    var lockedHatRequiredLevel by remember { mutableStateOf<Int?>(null) }

    val selectedFace = remember { mutableStateOf(Faces.Surprised) }

    val deviceInfo = rememberDeviceInfo()
    val isPhoneLargePortrait =
        deviceInfo.deviceClass == DeviceClass.PHONE_LARGE && !deviceInfo.isLandscape
    val avatarSize = when (deviceInfo.deviceClass) {
        DeviceClass.PHONE_SMALL -> 64.dp
        DeviceClass.PHONE_MEDIUM -> 80.dp
        DeviceClass.PHONE_LARGE -> if (isPhoneLargePortrait) 120.dp else 110.dp
        DeviceClass.TABLET_MEDIUM -> 120.dp
        DeviceClass.TABLET_LARGE -> 150.dp
        DeviceClass.WEB_FULL -> 150.dp
    }

    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(horizontal = 16.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Spacer(Modifier.size(16.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                Modifier.background(
                    color = backgroundOptions[bgColorIndex],
                    shape = RoundedCornerShape(6.dp)
                ).padding(top = 6.dp, start = 6.dp, end = 6.dp)
            ) {
                val avatarModifier = Modifier
                    .height(avatarSize)
                    .align(Alignment.BottomCenter)
                AlynAvatar(
                    userData = userData,
                    face = selectedFace.value,
                    modifier = avatarModifier
                )
            }

            Spacer(Modifier.width(16.dp))

            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = stringResource(Res.string.custom_title_face),
                    style = MaterialTheme.typography.titleMedium
                )
                Spacer(Modifier.height(6.dp))
                FaceMenu(
                    selectedFace = selectedFace.value,
                    onFaceSelected = { selectedFace.value = it }
                )
            }
        }

        Spacer(Modifier.size(20.dp))

        // hat/hatBar color index to snap to when each hat type is picked, in option order
        val hatTypeBaseColors = listOf(0 to 3, 11 to 2, 16 to 15, 0 to 4)

        val hatTypeOptionsRaw = listOf(
            Res.drawable.indiana to stringResource(Res.string.custom_hat_type_explorer),
            Res.drawable.basco to stringResource(Res.string.custom_hat_type_beret),
            Res.drawable.viking to stringResource(Res.string.custom_hat_type_viking),
            Res.drawable.egypt to stringResource(Res.string.custom_hat_type_egypt),
        )
        val hatTypeOptions = hatTypeOptionsRaw.mapIndexed { index, (drawable, description) ->
            val requiredLevel = hatTypeLevelRequirements[index]
            val locked = requiredLevel > 0 && userLevel < requiredLevel && !userData.isFullVersionUnlocked
            HatTypeOptionData(
                drawable = drawable,
                contentDescription = description,
                locked = locked,
                lockCaption = if (locked) {
                    stringResource(Res.string.custom_hat_locked_caption, requiredLevel)
                } else {
                    null
                }
            )
        }

        val hatTypeSectionContent: @Composable () -> Unit = {
            HatTypeSection(
                title = stringResource(Res.string.custom_title_hat_type),
                options = hatTypeOptions,
                selectedIndex = hatTypeIndex,
                onSelect = { index ->
                    onAlynColorChanged(CharacterConsts.HAT_TYPE_KEY, index)
                    val (hatColor, hatBarColor) = hatTypeBaseColors[index]
                    onAlynColorChanged("hat", hatColor)
                    onAlynColorChanged("hatBar", hatBarColor)
                },
                onLockedClick = { index -> lockedHatRequiredLevel = hatTypeLevelRequirements[index] }
            )
        }

        val sections = listOf(
            ColorSectionData(
                title = stringResource(Res.string.custom_title_bg),
                options = backgroundOptions,
                selectedIndex = bgColorIndex,
                onSelect = { onAlynColorChanged(CharacterConsts.BG_KEY, it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_body),
                options = skinOptions,
                selectedIndex = skinColorIndex,
                onSelect = { onAlynColorChanged("skin", it) }

            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_mouth),
                options = mouthOptions,
                selectedIndex = mouthColorIndex,
                onSelect = { onAlynColorChanged("mouth", it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_eyes),
                options = eyesOptions,
                selectedIndex = eyesColorIndex,
                onSelect = { onAlynColorChanged("eyes", it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_hair),
                options = hairOptions,
                selectedIndex = hairColorIndex,
                onSelect = { onAlynColorChanged("hair", it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_earrings),
                options = earringsOptions,
                selectedIndex = earringsIndex,
                onSelect = { onAlynColorChanged("earrings", it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_shirt),
                options = shirtOptions,
                selectedIndex = shirtColorIndex,
                onSelect = { onAlynColorChanged("shirt", it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_hat),
                options = hatOptions,
                selectedIndex = hatColorIndex,
                onSelect = { onAlynColorChanged("hat", it) }
            ),
            ColorSectionData(
                title = stringResource(Res.string.custom_title_hat_accent),
                options = hatBarOptions,
                selectedIndex = hatBarColorIndex,
                onSelect = { onAlynColorChanged("hatBar", it) }
            )
        )
        ColorsPicker(
            sections = sections,
            onResetClick = onResetClick,
            headerContent = hatTypeSectionContent
        )
    }

    val requiredLevel = lockedHatRequiredLevel
    if (requiredLevel != null) {
        AlertDialog(
            onDismissRequest = { lockedHatRequiredLevel = null },
            icon = {
                Icon(
                    imageVector = FeatherIcons.Lock,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.primary,
                    modifier = Modifier.size(28.dp)
                )
            },
            title = {
                Text(
                    text = stringResource(Res.string.custom_hat_locked_title),
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center
                )
            },
            text = {
                Text(
                    text = stringResource(Res.string.custom_hat_locked_desc, requiredLevel),
                    textAlign = TextAlign.Center
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        lockedHatRequiredLevel = null
                        onPurchaseFullVersion()
                    }
                ) {
                    Text(stringResource(Res.string.builder_pro_unlock_btn))
                }
            },
            dismissButton = {
                TextButton(onClick = { lockedHatRequiredLevel = null }) {
                    Text(stringResource(Res.string.chiudi_btn))
                }
            }
        )
    }
}
